/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Upgrade_SovereignInputs */

const en_domain_manager_upgrade_sovereign = /** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Sovereign for Unlimited Domains`)
};

const es_domain_manager_upgrade_sovereign = /** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora a Sovereign para Dominios Ilimitados`)
};

const fr_domain_manager_upgrade_sovereign = /** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Sovereign pour des domaines illimités`)
};

const de_domain_manager_upgrade_sovereign = /** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade auf Sovereign für unbegrenzte Domains`)
};

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const ja_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const zh_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const ar_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const id_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const it_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const ru_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const pt_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/** @type {(inputs: Domain_Manager_Upgrade_SovereignInputs) => LocalizedString} */
const ko_domain_manager_upgrade_sovereign = en_domain_manager_upgrade_sovereign;

/**
* | output |
* | --- |
* | "Upgrade to Sovereign for Unlimited Domains" |
*
* @param {Domain_Manager_Upgrade_SovereignInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_upgrade_sovereign = /** @type {((inputs?: Domain_Manager_Upgrade_SovereignInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Upgrade_SovereignInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_upgrade_sovereign(inputs)
	if (locale === "es") return es_domain_manager_upgrade_sovereign(inputs)
	if (locale === "fr") return fr_domain_manager_upgrade_sovereign(inputs)
	if (locale === "de") return de_domain_manager_upgrade_sovereign(inputs)
	if (locale === "ja") return ja_domain_manager_upgrade_sovereign(inputs)
	if (locale === "zh") return zh_domain_manager_upgrade_sovereign(inputs)
	if (locale === "ar") return ar_domain_manager_upgrade_sovereign(inputs)
	if (locale === "id") return id_domain_manager_upgrade_sovereign(inputs)
	if (locale === "it") return it_domain_manager_upgrade_sovereign(inputs)
	if (locale === "ru") return ru_domain_manager_upgrade_sovereign(inputs)
	if (locale === "pt") return pt_domain_manager_upgrade_sovereign(inputs)
	return ko_domain_manager_upgrade_sovereign(inputs)
});